import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

const AsSeenOn = () => {
  const images = [
    `${process.env.ADC_ASSETS_URL}/as-seen-on/Krix-6.webp`,
    `${process.env.ADC_ASSETS_URL}/as-seen-on/SA1.webp`,
    `${process.env.ADC_ASSETS_URL}/as-seen-on/St512.webp`,
    `${process.env.ADC_ASSETS_URL}/as-seen-on/WFAA-GMT.webp`,
    `${process.env.ADC_ASSETS_URL}/as-seen-on/weareAustin.webp`,
    `${process.env.ADC_ASSETS_URL}/as-seen-on/SanAntonioLiving.webp`,
    `${process.env.ADC_ASSETS_URL}/as-seen-on/KXAN.webp`,
    `${process.env.ADC_ASSETS_URL}/as-seen-on/Ksat12.webp`,
    `${process.env.ADC_ASSETS_URL}/as-seen-on/KPRC.webp`,
    `${process.env.ADC_ASSETS_URL}/as-seen-on/Nbc5.webp`,
    `${process.env.ADC_ASSETS_URL}/as-seen-on/Daytime.webp`,
    `${process.env.ADC_ASSETS_URL}/as-seen-on/CbsAustin.webp`,
    `${process.env.ADC_ASSETS_URL}/as-seen-on/GreatDaySA.webp`,
    `${process.env.ADC_ASSETS_URL}/as-seen-on/5-News.webp`,
    `${process.env.ADC_ASSETS_URL}/as-seen-on/14-KFOX.webp`,
    `${process.env.ADC_ASSETS_URL}/as-seen-on/SA1.webp`,
    `${process.env.ADC_ASSETS_URL}/as-seen-on/WFAA-GMT.webp`,
    `${process.env.ADC_ASSETS_URL}/as-seen-on/SanAntonioLiving.webp`,
  ];

  return (
    <div className="bg-white py-10">
      <h2 className="text-3xl text-center font-bold mx-auto mb-8 text-sky-700">
        As Interviewed On:
      </h2>
      <Swiper
        slidesPerView={3}
        breakpoints={{
          768: {
            slidesPerView: 7,
          },
          500: {
            slidesPerView: 4,
            spaceBetween: 40,
          },
        }}
        speed={500}
        autoplay={{
          disableOnInteraction: false,
        }}
        modules={[Autoplay]}
        loop
      >
        {images.map((url, index) => (
          <SwiperSlide key={index}>
            <img className="w-40 block mx-auto h-auto" src={url} alt="Logo" />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default AsSeenOn;
